import { Bar } from "react-chartjs-2";

export const BarChart = ({ chartData, text, display }) => {
  return (
    <div className="chart-container">
      <Bar
        type="bar"
        data={chartData}
        style={{ width: "100%" }}
        options={{
          responsive: true,
          plugins: {
            title: {
              legend: {
                position: "top",
              },
              display: true,
              text: text,
            },
            legend: {
              display,
            },
          },
        }}
      />
    </div>
  );
};
